import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import EnvironmentService from '../services/environmentService';
import { Codes } from '../models/index';
import HttpBase from '../models/httpBase';
import { Http, Response } from '@angular/http';
import { Router } from '@angular/router';
import 'rxjs/add/operator/map';
import PopupHelper from '../models/popupHelper';
@Injectable()
export class AuthenticationService extends HttpBase {

  constructor(http: Http, router: Router, private environmentService: EnvironmentService) {
    super(http, router);
  }

  login(username: string, password: string): Observable<Codes[]> {
    this.deleteLocalStorage();
    this.chngPass = false;
    return this.httpPost(this.environmentService.loginUrl, {
       userName: username,
      password
    }, true, false)
      .map((r: Response) => {
        if (r.status === 401 || r.status === 400 ) {
          this.statusCd = r.status;
        } else {
          if (r.status === 200) {
            this.reset = (r.json()).resetPassword;
            const expirationDt = (r.json()).passwordExpirationDate;
            this.loggedIn = r.status === 200;
            this.daysTillExpiration = this.isExpired(expirationDt);

          } else  if (r.status === 422) {
            return r.json().errorCodes;
          }
          this.statusCd = r.status;
        }
        const okCode: Codes[] = [Codes.ok];
        this.setLocalStorage();
        return okCode;
      });
  }
  checkAuthorization(environment: string, browser: string): Observable<string> {
    return this.httpGet(`${this.environmentService.checkAuthorizationtUrl}browser=${browser}&environment=${environment}`, false)
      .map((r: Response) => {
        return r.json();
      });
  }
  logout() {
    this.loggedIn = false;
    this.chngPass = false;
    sessionStorage.setItem('isLoggedIn', this.loggedIn.toString());
    sessionStorage.setItem('isChanged', this.chngPass.toString());
    return this.httpPost(this.environmentService.logoutUrl, {}, false);
  }

  isExpired(expirationDt: string): number {
    let duration = 0;
    const expireDt = new Date(expirationDt);
    const currentDt = new Date();

    if (this.expiredDate(expireDt, currentDt)) {
      const diff = Math.abs(expireDt.getTime() - currentDt.getTime());
      duration = Math.ceil(diff / (1000 * 3600 * 24));
    } else {
      duration = 0;
    }
    return duration;
  }
  expiredDate(expireDt: Date, currentDt: Date): Boolean {
    if (expireDt > currentDt) {
      return true;
    } else {
      return false;
    }
  }
  private setLocalStorage(): void {
    if (this.isLoggedIn !== undefined && this.isLoggedIn !== null ) {
      sessionStorage.setItem('isLoggedIn', this.isLoggedIn.toString());
    }
    if (this.chngPass !== undefined && this.chngPass !== null ) {
      sessionStorage.setItem('isChanged', this.chngPass.toString());
    }
    if (this.reset !== undefined && this.reset !== null ) {
      sessionStorage.setItem('isReset', this.reset.toString());
    }
    if (this.daysTillExpiration !== undefined && this.daysTillExpiration !== null) {
      sessionStorage.setItem('isExpiring', this.daysTillExpiration.toString());
    }
    if (this.statusCd !== undefined && this.statusCd !== null ) {
      sessionStorage.setItem('isStatusInvalid', this.statusCd.toString());
    }
  }
  private deleteLocalStorage(): void {
    sessionStorage.clear();
  }
  get isLoggedIn(): boolean {
    return this.loggedIn;
  }
  get isChanged(): boolean {
    return this.chngPass;
  }
  get isReset(): boolean {
    return this.reset;
  }
  get isExpiring(): number {
    return this.daysTillExpiration;
  }
  get isStatusInvalid(): number {
    return this.statusCd;
  }
  changePassword(userName: string, password: string, newPassword: string): Observable<Codes[]> {
    return this.httpPost(this.environmentService.changePasswordUrl, {
      UserName: userName,
      Password: password,
      NewPassword: newPassword
    }, true)
      .map((r: Response) => {
        if (r.status === 401 || r.status === 400 ) {
          PopupHelper.userHelper('Invalid user and/or password.  Please try again.  Access denied',
          'error');
        } else if (r.status === 422) {
          return r.json().errorCodes;
        }
        const okCode: Codes[] = [Codes.ok];
        return okCode;
      });
  }
  resetPassword(userName: string, email: string): Observable<Codes[]> {
    return this.httpPost(this.environmentService.resetUrl, {
      UserName: userName,
      Email: email
    }, true)
      .map((r: Response) => {
        this.statusCd = r.status;
        if (r.status === 422) {
          return r.json().errorCodes;
        }
        this.setLocalStorage();
        const okCode: Codes[] = [Codes.ok];
        return okCode;
      });
  }
  private loggedIn = false;
  private chngPass = false;
  private reset = false;
  private daysTillExpiration: number;
  private statusCd: number;
}




// WEBPACK FOOTER //
// ./src/services/authenticationService.ts